<template>
    <div>
        Blocked Senders
    </div>
</template>

<script>
export default {
  name: 'blockedSenders'
};
</script>

<style scoped>

</style>
